import {createQueryKeys} from '@lukemorales/query-key-factory'
import {api} from 'api'

export const financialExports = createQueryKeys('financialExports', {
  list: (url: string) => ({
    queryKey: [url],
    queryFn: () => api.financialExports.list(url),
  }),
})
